import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { QrObrasService } from "../services/qr-obra-service";

@Injectable({
  providedIn: 'root'
})
export class QrObraResolver implements Resolve<boolean> {

  constructor(private service: QrObrasService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}